var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefundSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6854 0H5.31351C2.04757 0 0 2.31243 0 5.58486V14.4151C0 17.6876 2.03784 20 5.31351 20H14.6843C17.9611 20 20 17.6876 20 14.4151V5.58486C20 2.31243 17.9611 0 14.6854 0ZM5.3706 8.62834C7.1615 6.50864 10.1576 5.71208 12.8149 6.92054C14.9326 7.88359 16.2126 9.93579 16.4079 12.073C16.4581 12.6219 16.0523 13.1086 15.5015 13.1602C14.9507 13.2117 14.4635 12.8084 14.4133 12.2595C14.2765 10.7628 13.3823 9.37534 11.9795 8.73741C10.5708 8.09678 9.00337 8.28155 7.79557 9.10359C8.21309 9.0896 8.6108 9.33903 8.76478 9.75046C8.95794 10.2666 8.69442 10.8422 8.17618 11.0362L5.5299 12.0265C5.27816 12.1207 4.99927 12.1102 4.75591 11.9974C4.51255 11.8846 4.32513 11.6789 4.23576 11.4265L3.28245 8.73447C3.09849 8.21499 3.37218 7.64408 3.89375 7.4593C4.41532 7.27453 4.98726 7.54586 5.17122 8.06534L5.3706 8.62834Z",
    fill: "#FA7800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundSvg);
export default __webpack_public_path__ + "static/media/refundSvg.3df663732689f003746fabe58a535dc1.svg";
export { ForwardRef as ReactComponent };